export const LANGUAGES = ['en', 'de', 'nl', 'fr', 'it', 'es', 'pt'];

export enum LanguagesEnum {
  EN = 'en',
  DE = 'de',
  NL = 'nl',
  FR = 'fr',
  IT = 'it',
  ES = 'es',
  PT = 'pt',
}
